// src/utils/fingerprint.js
export async function computeFingerprintHash() {
  const nav = window.navigator || {};
  const data = [
    nav.userAgent || "",
    nav.language || "",
    nav.platform || "",
    String(nav.hardwareConcurrency || ""),
    String(nav.deviceMemory || ""),
    `${window.screen?.width || ""}x${window.screen?.height || ""}`,
    String(new Date().getTimezoneOffset()),
  ].join("|");

  const enc = new TextEncoder().encode(data);
  const digest = await crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2, "0")).join("");
}
